import { Container } from 'reactstrap';


const PartnerPage = () => {
    return (
        <Container>
            
        </Container>
    );  
       
};

export default PartnerPage;